import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

import { Text } from '..';

const BtnContainer = styled.button`
  background-color: ${({ bgColor }) => theme.colorSets[bgColor].base};
  color: ${({ bgColor }) => theme.colorSets[bgColor].font};
  height: ${theme.buttonSizes.base};
  display: flex;
  justify-content: ${({ contentPosition }) => contentPosition};
  align-items: center;
  border: none;
  border-radius: ${theme.surface.borderRadius};
  padding: 0 ${theme.spacing.m};
  margin: 0;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  font-family: ${theme.fontStyles.family};

  &:hover {
    filter: ${({ bgColor }) => theme.colorSets[bgColor].hover};
  }

  &:active,
  &.active {
    filter: ${({ bgColor }) => theme.colorSets[bgColor].active};
  }

  &:disabled,
  &:disabled:hover,
  &.disabled {
    cursor: not-allowed;
    filter: ${({ bgColor }) => theme.colorSets[bgColor].disabled};
  }
`;

const TextButton = ({
  children,
  size,
  bgColor,
  contentPosition,
  disabled,
  ...props
}) => {
  const btnSize = {
    width: size === '100%' ? '100%' : 'auto',
  };

  let status = '';

  if (disabled) {
    status = 'disabled';
  }

  return (
    <BtnContainer
      {...props}
      contentPosition={contentPosition}
      bgColor={bgColor}
      className={status || undefined}
      style={{ ...btnSize, ...props.style }}
    >
      <Text block color={theme.colorSets[bgColor].font}>
        {disabled ? 'Loading...' : children}
      </Text>
    </BtnContainer>
  );
};

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['100%', 'inline']),
  bgColor: PropTypes.oneOf(['primary', 'secondary']),
  contentPosition: PropTypes.oneOf(['center', 'space-between']),
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

TextButton.defaultProps = {
  size: 'inline',
  bgColor: 'primary',
  contentPosition: 'center',
  disabled: false,
  style: {},
};

export default TextButton;
